export default function WhatIsTaxAssist() {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              What is the 2025 Tax Year?
            </h2>
            <p className="text-xl text-gray-600">
              Significant changes, new forms, and expanded requirements for Individual Tax Preparers
            </p>
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              The <strong>2025 U.S. Tax Year</strong> brings significant changes, new forms, expanded e-filing requirements, 
              and evolving regulations that impact Individual Tax Preparers (ICPs) and their clients. From inflation adjustments 
              and new digital asset reporting (Form 1099-DA) to expanded Direct File programs and mandatory e-filing thresholds, 
              tax professionals face a complex landscape requiring systematic preparation and modern tooling.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              While these changes are <strong>not a binding regulation</strong> in the traditional sense, they create critical 
              operational requirements for tax preparers, practices, and software developers who must prepare for the 2025 filing 
              season by understanding new forms, updated thresholds, digital asset reporting requirements, and the integration of 
              AI-assisted workflows into their practice.
            </p>
            
            <div className="bg-primary-50 border-l-4 border-primary-600 p-6 rounded-r-lg my-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Who Should Prepare?
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Individual Tax Preparers (ICPs): CPAs, enrolled agents, and tax professionals</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Pass-Through Entity Specialists: Professionals handling partnerships and S-corps</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Tax Software Developers: Teams building tax preparation and e-filing systems</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Practice Managers: Leaders responsible for workflow modernization and compliance</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>AI-Enhanced Tax Workflows: Teams integrating AI assistants into tax processing</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-accent-50 border-l-4 border-accent-600 p-6 rounded-r-lg my-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Key 2025 Changes
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">•</span>
                  <span><strong>New Form 1099-DA:</strong> Digital Asset Broker Reporting requirements</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">•</span>
                  <span><strong>Inflation Adjustments:</strong> Updated tax brackets, standard deduction, AMT thresholds</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">•</span>
                  <span><strong>Retirement Limits:</strong> Increased 401(k) ($23,000) and IRA ($7,000) contribution limits</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">•</span>
                  <span><strong>K-1 Updates:</strong> Updated schedules for partnerships and S-corps</span>
                </li>
                <li className="flex items-start">
                  <span className="text-accent-600 mr-2">•</span>
                  <span><strong>E-Filing Expansion:</strong> Mandatory e-filing for more business returns</span>
                </li>
              </ul>
            </div>
            
            <p className="text-gray-700 leading-relaxed">
              <strong>Harbor Agent's value is simple:</strong> We translate complex, evolving tax regulations into preparer-ready 
              checklists, AI-native workflows, and systematic preparation tools that your practice can actually use. The AI Tax 
              Assistant Readiness Pack is Pack #2 in the Harbor Agent line.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

